import { logEvent, CustomParams } from 'firebase/analytics';
import { analytics } from '../Utils/firebaseConfig';
import { AnalyticsEventParams } from '../helpers/analyticsEvents';

export function useAnalytics() {
  const track = <T extends keyof AnalyticsEventParams>(
    eventName: T,
    params?: AnalyticsEventParams[T],
  ) => {
    try {
      console.log('eventName', eventName);
      logEvent(analytics, eventName as string, {
        platform: 'web',
        ...(params as CustomParams),
      });
    } catch (error) {
      console.warn('Analytics logEvent failed:', error);
    }
  };

  return { track };
}
